import React, { forwardRef, useImperativeHandle, useState } from 'react'

import { ICellEditorParams } from 'ag-grid-community'
import { Form, Formik } from 'formik'

import TextEditorField from '@/components/FormikInputs/TextEditorField'

export const OpsDelayReasonCellEditor = forwardRef(function OpsDelayReasonCellEditor(
  props: ICellEditorParams,
  ref
) {
  const { value } = props
  const [outterValue, setOutterValue] = useState(value)
  /* Component Editor Lifecycle methods */
  useImperativeHandle(ref, () => {
    return {
      getValue() {
        return outterValue
      },

      // Gets called once before editing starts, to give editor a chance to
      // cancel the editing before it even starts.
      isCancelBeforeStart() {
        return false
      },
    }
  })

  return (
    <div className='max-w-[460px]'>
      <Formik
        initialValues={{
          content: value || '',
        }}
        onSubmit={async (values: { content: string }) => {
          setOutterValue(values.content)
          setTimeout(() => props.stopEditing())
        }}
      >
        {({ submitForm, setFieldValue }) => (
          <Form className='font-normal'>
            <TextEditorField
              defaultShowEditor
              onChangeApplied={submitForm}
              placeholder='Enter Delay Reasons'
              setFieldValue={setFieldValue}
              name='content'
              onCancel={() => props.stopEditing()}
            />
          </Form>
        )}
      </Formik>
    </div>
  )
})
